import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "flex-1 overflow-y-auto p-6 space-y-6"
};
const _hoisted_2 = {
  class: "flex items-center gap-3"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  key: 1,
  class: "w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center"
};
const _hoisted_5 = {
  class: "flex-1"
};
const _hoisted_6 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_7 = {
  class: "text-xs text-slate-500"
};
const _hoisted_8 = {
  class: "flex items-center gap-2 flex-wrap"
};
const _hoisted_9 = {
  class: "status-badge is-info"
};
const _hoisted_10 = {
  class: "status-badge is-purple"
};
const _hoisted_11 = {
  key: 0,
  class: "status-badge is-orange"
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  class: "text-sm text-slate-700 leading-relaxed whitespace-pre-wrap"
};
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = {
  class: "grid grid-cols-3 gap-2"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  key: 2
};
const _hoisted_19 = {
  class: "rounded-lg overflow-hidden border border-slate-200"
};
const _hoisted_20 = ["src", "poster"];
const _hoisted_21 = {
  key: 3
};
const _hoisted_22 = {
  class: "bg-slate-50 rounded-lg p-3 border border-slate-200"
};
const _hoisted_23 = {
  class: "text-sm text-slate-700"
};
const _hoisted_24 = {
  class: "text-xs text-blue-600 mt-1 break-all"
};
const _hoisted_25 = {
  class: "grid grid-cols-3 gap-3"
};
const _hoisted_26 = {
  class: "bg-slate-50 rounded-lg p-3 text-center border border-slate-200"
};
const _hoisted_27 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_28 = {
  class: "bg-slate-50 rounded-lg p-3 text-center border border-slate-200"
};
const _hoisted_29 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_30 = {
  class: "bg-slate-50 rounded-lg p-3 text-center border border-slate-200"
};
const _hoisted_31 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_32 = {
  key: 4
};
const _hoisted_33 = {
  class: "bg-orange-50 rounded-lg p-3 border border-orange-200 text-sm"
};
const _hoisted_34 = {
  class: "flex items-center gap-4"
};
const _hoisted_35 = {
  class: "text-slate-600"
};
const _hoisted_36 = {
  class: "text-slate-900 font-medium"
};
const _hoisted_37 = {
  class: "text-slate-600"
};
const _hoisted_38 = {
  class: "text-slate-900 font-medium"
};
const _hoisted_39 = {
  key: 5
};
const _hoisted_40 = {
  class: "bg-red-50 rounded-lg p-3 border border-red-200"
};
const _hoisted_41 = {
  class: "text-sm text-red-700"
};
const _hoisted_42 = {
  key: 6
};
const _hoisted_43 = {
  class: "text-sm text-slate-600"
};
const _hoisted_44 = {
  class: "relative"
};
const _hoisted_45 = ["src"];
import { ref, computed } from 'vue';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'CircleDetailModal',
  props: {
    show: Boolean,
    postData: Object
  },
  emits: ['update:show'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;

    // 图片预览
    const showImagePreview = ref(false);
    const previewImageUrl = ref('');
    const handleClose = () => {
      emit('update:show', false);
    };
    const imageList = computed(() => {
      if (!props.postData?.images) return [];
      return props.postData.images.split(',').filter(url => url.trim());
    });
    const formatTime = time => {
      if (!time) return '-';
      return time.replace('T', ' ').substring(0, 16);
    };
    const sourceLabel = computed(() => {
      if (!props.postData) return '-';
      return props.postData.source === 0 ? 'C端用户' : '平台';
    });
    const contentTypeLabel = computed(() => {
      if (!props.postData) return '-';
      return props.postData.contentType === 1 ? '图文' : '短视频';
    });
    const statusConfig = {
      0: {
        label: '待审核',
        dot: 'bg-amber-400',
        bg: 'bg-amber-50',
        text: 'text-amber-700'
      },
      1: {
        label: '已通过',
        dot: 'bg-green-500',
        bg: 'bg-green-50',
        text: 'text-green-700'
      },
      2: {
        label: '已拒绝',
        dot: 'bg-red-400',
        bg: 'bg-red-50',
        text: 'text-red-700'
      },
      3: {
        label: '已下架',
        dot: 'bg-slate-400',
        bg: 'bg-slate-100',
        text: 'text-slate-700'
      }
    };
    const openImagePreview = url => {
      previewImageUrl.value = url;
      showImagePreview.value = true;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: __props.show,
          size: "2xl",
          onClose: handleClose
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between shrink-0"
          }, [_cache[3] || (_cache[3] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "动态详情", -1)), _createElementVNode("button", {
            onClick: handleClose,
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer"
          }, [...(_cache[2] || (_cache[2] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), __props.postData ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [__props.postData.userAvatar ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.postData.userAvatar,
            class: "w-10 h-10 rounded-full object-cover border border-slate-200"
          }, null, 8, _hoisted_3)) : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[4] || (_cache[4] = [_createElementVNode("svg", {
            class: "w-5 h-5 text-primary-600",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          })], -1)]))])), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(__props.postData.userNickname || '未知用户'), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(formatTime(__props.postData.createTime)), 1)]), _createElementVNode("span", {
            class: _normalizeClass(["status-badge", [statusConfig[__props.postData.status]?.bg, statusConfig[__props.postData.status]?.text]])
          }, [_createElementVNode("span", {
            class: _normalizeClass(["w-1.5 h-1.5 rounded-full mr-1.5", statusConfig[__props.postData.status]?.dot])
          }, null, 2), _createTextVNode(" " + _toDisplayString(statusConfig[__props.postData.status]?.label || '未知'), 1)], 2)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(sourceLabel.value), 1), _createElementVNode("span", _hoisted_10, _toDisplayString(contentTypeLabel.value), 1), __props.postData.isTop === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_11, " 置顶 ")) : _createCommentVNode("", true)]), __props.postData.content ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_cache[5] || (_cache[5] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900 mb-2"
          }, "动态内容", -1)), _createElementVNode("p", _hoisted_13, _toDisplayString(__props.postData.content), 1)])) : _createCommentVNode("", true), imageList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_cache[7] || (_cache[7] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900 mb-2"
          }, "图片", -1)), _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageList.value, (url, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: "relative aspect-square rounded-lg overflow-hidden border border-slate-200 cursor-pointer group",
              onClick: $event => openImagePreview(url)
            }, [_createElementVNode("img", {
              src: url,
              class: "w-full h-full object-cover"
            }, null, 8, _hoisted_17), _cache[6] || (_cache[6] = _createElementVNode("div", {
              class: "absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center"
            }, [_createElementVNode("svg", {
              class: "w-6 h-6 text-white opacity-0 group-hover:opacity-100 transition-opacity",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
            })])], -1))], 8, _hoisted_16);
          }), 128))])])) : _createCommentVNode("", true), __props.postData.contentType === 2 && __props.postData.videoUrl ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_cache[8] || (_cache[8] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900 mb-2"
          }, "视频", -1)), _createElementVNode("div", _hoisted_19, [_createElementVNode("video", {
            src: __props.postData.videoUrl,
            poster: __props.postData.videoCover,
            controls: "",
            class: "w-full max-h-80"
          }, null, 8, _hoisted_20)])])) : _createCommentVNode("", true), __props.postData.linkUrl ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_cache[9] || (_cache[9] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900 mb-2"
          }, "跳转链接", -1)), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(__props.postData.linkTitle || '无标题'), 1), _createElementVNode("div", _hoisted_24, _toDisplayString(__props.postData.linkUrl), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", null, [_cache[13] || (_cache[13] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900 mb-2"
          }, "互动数据", -1)), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString(__props.postData.viewCount || 0), 1), _cache[10] || (_cache[10] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mt-0.5"
          }, "浏览量", -1))]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, _toDisplayString(__props.postData.likeCount || 0), 1), _cache[11] || (_cache[11] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mt-0.5"
          }, "点赞数", -1))]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, _toDisplayString(__props.postData.favoriteCount || 0), 1), _cache[12] || (_cache[12] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mt-0.5"
          }, "收藏数", -1))])])]), __props.postData.isTop === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_cache[16] || (_cache[16] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900 mb-2"
          }, "置顶信息", -1)), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("span", _hoisted_35, [_cache[14] || (_cache[14] = _createTextVNode("排序值：", -1)), _createElementVNode("span", _hoisted_36, _toDisplayString(__props.postData.topSort || 0), 1)]), _createElementVNode("span", _hoisted_37, [_cache[15] || (_cache[15] = _createTextVNode("过期时间：", -1)), _createElementVNode("span", _hoisted_38, _toDisplayString(formatTime(__props.postData.topExpireTime) || '永不过期'), 1)])])])])) : _createCommentVNode("", true), __props.postData.status === 2 && __props.postData.rejectReason ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_cache[17] || (_cache[17] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900 mb-2"
          }, "拒绝原因", -1)), _createElementVNode("div", _hoisted_40, [_createElementVNode("p", _hoisted_41, _toDisplayString(__props.postData.rejectReason), 1)])])) : _createCommentVNode("", true), __props.postData.auditTime ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_cache[18] || (_cache[18] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900 mb-2"
          }, "审核信息", -1)), _createElementVNode("div", _hoisted_43, " 审核时间：" + _toDisplayString(formatTime(__props.postData.auditTime)), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", {
            class: "px-6 py-4 border-t border-slate-200 flex items-center justify-end shrink-0"
          }, [_createElementVNode("button", {
            onClick: handleClose,
            class: "px-4 py-2 border border-slate-300 text-slate-700 rounded-lg text-sm hover:bg-slate-50 transition-colors cursor-pointer"
          }, " 关闭 ")])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      }), _createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: showImagePreview.value,
          size: "none",
          "panel-class": "max-w-[90vw]",
          "z-index": 60,
          onClose: _cache[1] || (_cache[1] = $event => showImagePreview.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_44, [_createElementVNode("img", {
            src: previewImageUrl.value,
            alt: "大图预览",
            class: "max-w-full max-h-[85vh] rounded-lg object-contain"
          }, null, 8, _hoisted_45), _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = $event => showImagePreview.value = false),
            class: "absolute -top-3 -right-3 flex h-8 w-8 items-center justify-center rounded-full bg-white shadow-lg text-slate-500 hover:text-slate-700 transition-colors cursor-pointer"
          }, [...(_cache[19] || (_cache[19] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })]);
    };
  }
};